import { Row, Form, Radio, DatePicker, Select, Col, Space, Input } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormInput from 'components/FormInput';
import ButtonLink from 'components/theme_components/ButtonLink';
import TextArea from 'antd/lib/input/TextArea';
import { addParTaxRate, ParTaxResponse2 } from 'services/parametersService';
import ParListSelect from 'components/ParListSelect';
import Notifications from 'components/theme_components/Notifications';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'components/Auth/Auth';
import InputRate from 'components/InputRate';
import IBasket from 'icons/IBasket';
import ModalSFS from 'components/theme_components/ModalSFS';
import { toDatePickerDate } from 'utils/utils2';

export type ParTaxeValueModalProps = {
  setVisible: (visible: boolean) => void;
  setAddRateValue?: (addRateValue: boolean) => void;
  data: any;
  refetch: any;
};

const ParTaxeValueModal = ({
  setVisible,
  setAddRateValue,
  data,
  refetch,
}: ParTaxeValueModalProps) => {
  const [form] = useForm();
  const { isInspect } = useContext(AuthContext);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleSussp, setModalVisibleSussp] = useState(false);

  const [modalVisibleDelet, setmodalVisibleDelet] = useState(false);
  console.log({ data });
  const id = undefined;
  useEffect(() => {
    if (data) {
      console.log('data', data)
      form.setFieldsValue({
        partaxrate: data.partaxrate,
        taxtype: data.taxtype,
        taxcode: data.taxcode,
        taxflow: data.taxflow,
        taxlabel: data.taxlabel,
        begindate: toDatePickerDate(data.begindate),
        enddate: toDatePickerDate(data.enddate),
        taxdescription: data.taxdescription,

      });
    }
  }, [data]);
  const submit = (values: any) => {
  
  };

  return (
    <Form form={form} className="no-border-radius ut-wizard-form">
      <Row gutter={16} justify="space-between">
      
      
      <FormInput
          col
          xs={24}
          lg={24}
          name="action"
          labelCol={{ span: 24 }}
          className="no-border-radius"
        >
          <ParListSelect parcode="TAXFLOW" disabled />

        </FormInput>
        
      
       
        <FormInput
          col
          xs={24}
          lg={24}
          name="addcomment"
          labelCol={{ span: 24 }}
          className=""
        >
          <TextArea size="middle" rows={3} className="texterea mb-50" />
        </FormInput>
      </Row>

        <Row justify={'end'}className='mt-8'>
      
     
          <ButtonLink
            comcode="Annuler"
            className="ut-btn-bordred"
            onClick={() => !isInspect&&setVisible(false)}
            
          />

          <ButtonLink
            type="primary"
            comcode="Valider"
            htmlType="submit"
            className="ut-reset-btn ml-6"
            onClick={(values: any) => {
              !isInspect&&submit(values);
            }}
            iconPosition="end"
            disabled
          />
      
      </Row>
     
    
    </Form>
  );
};

export default ParTaxeValueModal;
